
import { defineNuxtPlugin } from '#app'


import VueGtag, { trackRouter } from 'vue-gtag-next'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueGtag, {
        property: {
            id: 'G-Z1CH25EPYV'
        }
    })
    trackRouter(useRouter())
})
